import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CampaignService {
  private http = inject(HttpClient);
  private url = `${environment.url.api}/campaign`;

  startCampaign(data: object): Observable<string> {
    return this.http.post<{ applicationRoute: string }>(`${this.url}/start`, data).pipe(
      map((response: { applicationRoute: string }) => {
        return response.applicationRoute;
      })
    );
  }
}
